import { render, staticRenderFns } from "./RequirementView.vue?vue&type=template&id=8e5d9f0e&scoped=true"
import script from "./RequirementView.vue?vue&type=script&lang=js"
export * from "./RequirementView.vue?vue&type=script&lang=js"
import style0 from "./RequirementView.vue?vue&type=style&index=0&id=8e5d9f0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5d9f0e",
  null
  
)

export default component.exports